import { useEffect } from "react";

export function useAddressNow(apiKey, configCallback) {
  useEffect(() => {
    if (window.addressnow) {
      if (configCallback) configCallback(window.addressnow);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://api.addressnow.co.uk/js/addressnow-2.30.min.js?key=${apiKey}`;
    script.async = true;

    const handleLoad = () => {
      if (window.addressnow && configCallback) {
        configCallback(window.addressnow);
      }
    };

    script.addEventListener("load", handleLoad);
    document.body.appendChild(script);

    return () => {
      script.removeEventListener("load", handleLoad);
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      document.querySelectorAll(".pca").forEach((el) => el.remove());

      delete window.addressnow;
    };
  }, []);
}
